import { GoogleTagManagerService } from "angular-google-tag-manager";
import { LocalStorageService } from "src/app/global/services/localstorage.service";
import { CarroComprasService } from "src/app/view-model/services/carro-compras.service";
import { environment } from "src/environments/environment";
import { TagManagerGA4Provider } from "./tag-manager-ga4.provider";
import { TagManagerProvider } from "./tag-manager.provider";


export function TagManagerFactory( storageServ: LocalStorageService,
                                   carroService: CarroComprasService,
                                   googleTagManagerService: GoogleTagManagerService
                                   ) {   
    if (environment.isGA4tagManager) {
       return new TagManagerGA4Provider(storageServ,carroService,googleTagManagerService);
    }
    return new TagManagerProvider(storageServ,carroService,googleTagManagerService);

}